/**
 * Created by christiancueni on 29/07/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'hc-public-header',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
      <div class="row bg-dark-blue">
        <div class="main-title col-xs-12 col-md-11 col-md-offset-1">
          <a routerLink="/"><h1 class="qa-title inverted main-title__heading">{{"Helloclass" | translate}}</h1></a>
          <p class="qa-subtitle claim inverted">
            {{"Das digitale Klassenbuch, das Lehrpersonen,"| translate}}<br />{{"Schüler/innen und Eltern verbindet." | translate}}
          </p>
        </div>
      </div> 
    `,
})
export class PublicHeaderComponent {
}
